import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import {
  consolelog,
  delCancelToken,
  checkCancelToken,
  convertSearchOptions,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

const getWorkRecords =
  (apiToken, searchOptions = {}, responseAction, provider) =>
  dispatch => {
    consolelog('[API CALL] getWorkRecords()', searchOptions);
    configureAxiosForJSON(apiToken);
    const url = endpoint.API_GET_WORK_RECORDS;
    const { cancelToken, cancelTokenKey } = createCancelToken('getWorkRecords');
    const convertedSearchOptions = convertSearchOptions(searchOptions);
    if (provider && provider.isCansuke) {
      convertedSearchOptions.mediaTypes = [1];
    }
    const params = {
      ...convertedSearchOptions,
      cancelToken,
    };
    // TODO ローディングが一瞬で判別ができないので一旦非表示にする
    // dispatch({ type: 'OPEN_LOADING' });
    return axios
      .post(url, params)
      .then(res => {
        if (checkCancelToken(cancelTokenKey)) {
          dispatch({
            type:
              (responseAction && responseAction) ||
              actionTypes.SUCCESS_API_GET_WORK_RECORDS,
            payload: res.data,
          });
        }
        delCancelToken(cancelTokenKey);
      })
      .catch(thrown => {
        delCancelToken(cancelTokenKey);
        if (!axios.isCancel(thrown)) {
          handleErrorResponse(thrown, dispatch);
        }
      });
  };

export default getWorkRecords;
